@import 'styles/variables';
@import 'styles/mixins.scss';
@import 'styles/blaze/mixins';

.formTitle {
  @include md-sohne;
  text-align: left;
  color: var(--Neutral-90, #2b2f38);
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: 0.32px;
  span {
    color: red;
  }
}

.leftContent {
  padding: 0 24px;
  margin: 32px auto;
  max-width: 531px;
}

.gapHeading {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
}

.contentWrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: center;

  @include for-desktop-up {
    padding-top: 50px;
    margin-left: 40px;
    margin-right: 40px;
  }

  @include for-tablet-portrait-max {
    width: 100%;
    margin: 0 auto;
  }
}

.imgBackgroundFull {
  background-image: url('https://res.cloudinary.com/almanac/image/upload/v1715063625/blaze_assets/backgrounds/first_time_experience/hilly_background_l04ye0.png');
  background-size: 100%;
  background-color: rgba(155, 211, 255, 0.8);
  background-position: bottom center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  border-radius: 16px;
  width: 100%;
  @include for-phone-only {
    border-radius: unset;
    position: fixed;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
  }
}

.spinner {
  position: absolute;
  bottom: 140px;

  > div {
    background: conic-gradient(
      from 90deg at 50% 50%,
      rgba(143, 152, 169, 0) 0deg,
      black 359.96deg,
      rgba(143, 152, 169, 0) 360deg
    );
    &::after {
      background-color: transparent;
    }
  }
}

.buttonContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 36px;
}

.wrapper {
  display: flex;
  padding: 18px 30px 30px 30px;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
  flex-shrink: 0;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.logo {
  height: 26px;
  width: auto;
}

.heading {
  color: var(--dark-80);
  font-family: Sohne;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
  letter-spacing: 0.44px;
  padding: 0;
  margin: 0;
  text-align: center;
  width: 100%;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 18px 30px 30px 30px;
  gap: 18px;
  align-self: stretch;
  overflow: auto;
  height: 100%;
  max-width: 580px;
  margin: 0 auto;
}

.form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
  align-self: stretch;
}

.field {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
}

.label {
  color: var(--dark-90);
  font-family: Sohne;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: 0.32px;

  .required {
    color: var(--red-50);
  }
}

.buttonGroup {
  display: flex;
  width: 100%;
  gap: 10px;
  justify-content: flex-end;
}

.popover {
  height: 30vh;
}

.backdrop {
  position: relative !important;
  z-index: 1;
}

.footer {
  padding: 17px 30px 30px 30px;
  flex-direction: column;
  display: flex;
  margin: 0;
}

@media (min-width: $tabletPortraitMinWidth) {
  .modalBody {
    width: 800px !important;
  }

  .content {
    padding: 75px 0;
    gap: 30px;
  }

  .logo {
    height: 28px;
  }

  .heading {
    font-size: 32px;
    font-weight: 600;
    line-height: 110%;
  }

  .buttonGroup {
    flex-direction: row;
    gap: 8px;
    justify-content: flex-end;
  }

  .languageSelect {
    width: 240px;
  }

  .form {
    gap: 30px;
  }
}
